import ActivitySVG from '@public/icons/icon-marketplace-planet-activity.svg'
import ItemsSVG from '@public/icons/icon-marketplace-planet-items.svg'
import SharedThirdNavBar, {
  NavigationItem
} from '@src/components/navigationBar/third/SharedThirdNavBar'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import { FC, useMemo } from 'react'

const PlanetThirdNavBar: FC<Props> = (props: Props) => {
  const { index = 0 } = props

  const navigationItems: NavigationItem[] = useMemo(
    () => [
      {
        icon: ItemsSVG,
        route: ROUTE.MARKETPLACE_PLANET_LIST,
        translationKey: 'sub_bar.marketplace.tabs.items'
      },
      {
        icon: ActivitySVG,
        route: ROUTE.MARKETPLACE_PLANET_ACTIVITY_LIST,
        translationKey: 'sub_bar.marketplace.tabs.activities'
      }
    ],
    []
  )

  return (
    <SharedThirdNavBar
      height={NAV_BAR_CONFIG.tertiary.height}
      index={index}
      navigationItems={navigationItems}
    />
  )
}

type Props = {
  index: number
}

export default PlanetThirdNavBar
